import { loggerFactory } from '@accor/customer-core'

// Todo: Update this to include pmid if cookie is accepted by the user
const info = () => ({
  project: 'Customer Account'
})

export const isDevMode = () => window?.localStorage.getItem('isDev')

export const { logger } = loggerFactory({
  context: 'Customer Account',
  adapters: [],
  info,
  devMode: isDevMode
})
